export function gFormsInit() {
	document.addEventListener( 'gform/post_render', () => {
		const validationWrapper = document.querySelectorAll( '.gform_validation_errors' );

		if ( validationWrapper ) {
			validationWrapper.forEach( ( wrapper ) => {
				const labelText = wrapper.querySelector( '.gform_submission_error' ).innerText;

				wrapper.setAttribute( 'role', 'region' );
				wrapper.setAttribute( 'aria-label', labelText );
			} );
		}
	} );
}
